import { commonjsGlobal as p } from "../../../../../_virtual/_commonjsHelpers.js";
var R = 9007199254740991, J = "[object Arguments]", q = "[object Function]", B = "[object GeneratorFunction]", b = "[object Map]", X = "[object Object]", M = "[object Promise]", h = "[object Set]", Z = "[object String]", C = "[object WeakMap]", k = "[object DataView]", Q = /[\\^$.*+?()[\]{}|]/g, Y = /^\[object .+?Constructor\]$/, rr = /^(?:0|[1-9]\d*)$/, v = "\\ud800-\\udfff", I = "\\u0300-\\u036f\\ufe20-\\ufe23", _ = "\\u20d0-\\u20f0", V = "\\ufe0e\\ufe0f", tr = "[" + v + "]", m = "[" + I + _ + "]", S = "\\ud83c[\\udffb-\\udfff]", nr = "(?:" + m + "|" + S + ")", $ = "[^" + v + "]", F = "(?:\\ud83c[\\udde6-\\uddff]){2}", G = "[\\ud800-\\udbff][\\udc00-\\udfff]", L = "\\u200d", N = nr + "?", D = "[" + V + "]?", er = "(?:" + L + "(?:" + [$, F, G].join("|") + ")" + D + N + ")*", or = D + N + er, ir = "(?:" + [$ + m + "?", m, F, G, tr].join("|") + ")", ar = RegExp(S + "(?=" + S + ")|" + ir + or, "g"), cr = RegExp("[" + L + v + I + _ + V + "]"), ur = typeof p == "object" && p && p.Object === Object && p, sr = typeof self == "object" && self && self.Object === Object && self, i = ur || sr || Function("return this")();
function fr(r, t) {
  for (var n = -1, e = r ? r.length : 0, c = Array(e); ++n < e; )
    c[n] = t(r[n], n, r);
  return c;
}
function pr(r) {
  return r.split("");
}
function gr(r, t) {
  for (var n = -1, e = Array(r); ++n < r; )
    e[n] = t(n);
  return e;
}
function dr(r, t) {
  return fr(t, function(n) {
    return r[n];
  });
}
function lr(r, t) {
  return r == null ? void 0 : r[t];
}
function yr(r) {
  return cr.test(r);
}
function br(r) {
  var t = !1;
  if (r != null && typeof r.toString != "function")
    try {
      t = !!(r + "");
    } catch {
    }
  return t;
}
function hr(r) {
  for (var t, n = []; !(t = r.next()).done; )
    n.push(t.value);
  return n;
}
function mr(r) {
  var t = -1, n = Array(r.size);
  return r.forEach(function(e, c) {
    n[++t] = [c, e];
  }), n;
}
function Sr(r, t) {
  return function(n) {
    return r(t(n));
  };
}
function jr(r) {
  var t = -1, n = Array(r.size);
  return r.forEach(function(e) {
    n[++t] = e;
  }), n;
}
function Ar(r) {
  return yr(r) ? Tr(r) : pr(r);
}
function Tr(r) {
  return r.match(ar) || [];
}
var Or = Function.prototype, g = Object.prototype, l = i["__core-js_shared__"], E = function() {
  var r = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}(), K = Or.toString, d = g.hasOwnProperty, u = g.toString, wr = RegExp(
  "^" + K.call(d).replace(Q, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), P = i.Symbol, y = P ? P.iterator : void 0, vr = g.propertyIsEnumerable, xr = Sr(Object.keys, Object), j = s(i, "DataView"), A = s(i, "Map"), T = s(i, "Promise"), O = s(i, "Set"), w = s(i, "WeakMap"), Mr = a(j), Cr = a(A), kr = a(T), Er = a(O), Pr = a(w);
function Rr(r, t) {
  var n = U(r) || Nr(r) ? gr(r.length, String) : [], e = n.length, c = !!e;
  for (var f in r)
    d.call(r, f) && !(c && (f == "length" || Fr(f, e))) && n.push(f);
  return n;
}
function Ir(r) {
  return u.call(r);
}
function _r(r) {
  if (!z(r) || Gr(r))
    return !1;
  var t = W(r) || br(r) ? wr : Y;
  return t.test(a(r));
}
function Vr(r) {
  if (!Lr(r))
    return xr(r);
  var t = [];
  for (var n in Object(r))
    d.call(r, n) && n != "constructor" && t.push(n);
  return t;
}
function $r(r, t) {
  var n = -1, e = r.length;
  for (t || (t = Array(e)); ++n < e; )
    t[n] = r[n];
  return t;
}
function s(r, t) {
  var n = lr(r, t);
  return _r(n) ? n : void 0;
}
var o = Ir;
(j && o(new j(new ArrayBuffer(1))) != k || A && o(new A()) != b || T && o(T.resolve()) != M || O && o(new O()) != h || w && o(new w()) != C) && (o = function(r) {
  var t = u.call(r), n = t == X ? r.constructor : void 0, e = n ? a(n) : void 0;
  if (e)
    switch (e) {
      case Mr:
        return k;
      case Cr:
        return b;
      case kr:
        return M;
      case Er:
        return h;
      case Pr:
        return C;
    }
  return t;
});
function Fr(r, t) {
  return t = t ?? R, !!t && (typeof r == "number" || rr.test(r)) && r > -1 && r % 1 == 0 && r < t;
}
function Gr(r) {
  return !!E && E in r;
}
function Lr(r) {
  var t = r && r.constructor, n = typeof t == "function" && t.prototype || g;
  return r === n;
}
function a(r) {
  if (r != null) {
    try {
      return K.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
function Nr(r) {
  return Dr(r) && d.call(r, "callee") && (!vr.call(r, "callee") || u.call(r) == J);
}
var U = Array.isArray;
function x(r) {
  return r != null && Kr(r.length) && !W(r);
}
function Dr(r) {
  return H(r) && x(r);
}
function W(r) {
  var t = z(r) ? u.call(r) : "";
  return t == q || t == B;
}
function Kr(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= R;
}
function z(r) {
  var t = typeof r;
  return !!r && (t == "object" || t == "function");
}
function H(r) {
  return !!r && typeof r == "object";
}
function Ur(r) {
  return typeof r == "string" || !U(r) && H(r) && u.call(r) == Z;
}
function Wr(r) {
  if (!r)
    return [];
  if (x(r))
    return Ur(r) ? Ar(r) : $r(r);
  if (y && r[y])
    return hr(r[y]());
  var t = o(r), n = t == b ? mr : t == h ? jr : Hr;
  return n(r);
}
function zr(r) {
  return x(r) ? Rr(r) : Vr(r);
}
function Hr(r) {
  return r ? dr(r, zr(r)) : [];
}
var qr = Wr;
export {
  qr as l
};
